// extracted by mini-css-extract-plugin
module.exports = {"subItem":"nestedItem_subItem__3Lsum","item_details":"nestedItem_item_details__BGp0X","tag_type":"nestedItem_tag_type__2OIjq","list_item":"nestedItem_list_item__2WfXD"};